import { Layout as BaseLayout, Grid } from 'antd';
import { FC, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer, Header } from './index';
import {
  HEADER_SLOT_CLASS,
  HEADER_SLOT_SCROLLED_CLASS,
} from '@/components/layout/MobileHeader';
import { useIsPageScrolled } from '@/components/layout/MobileHeader/useIsPageScrolled';
import './Layout.scss'

const Layout: FC = () => {
  const { lg } = Grid.useBreakpoint();
  const isScrolled = useIsPageScrolled();

  return (
    <BaseLayout className={'user-layout landing-layout'}>
      <BaseLayout.Header
        className={
          isScrolled
            ? `${HEADER_SLOT_CLASS} ${HEADER_SLOT_SCROLLED_CLASS}`
            : HEADER_SLOT_CLASS
        }
        style={lg ? undefined : { padding: 0 }}
      >
        <Header />
      </BaseLayout.Header>

      <BaseLayout.Content style={{ minHeight: '100dvh' }}>
        <Suspense>
          <Outlet />
        </Suspense>
      </BaseLayout.Content>

      <BaseLayout.Footer>
        <Footer />
      </BaseLayout.Footer>
    </BaseLayout>
  );
};

export { Layout };
